module.exports = __webpack_public_path__ + "static/media/swap2.ba60d10b.svg";